import { ConnectionType } from 'Quotes/types/connectionType';
import { IPriceData, ProductSubType } from 'Quotes/types/store';
import { ProductType } from 'Quotes/types/productTypes';
import { isSupplier, Supplier } from 'Quotes/types/supplier';
import { QuoteStatus } from 'Quotes/types/quoteRecordAttributesBase';
import { useSelector } from 'react-redux';
import { isFTTXQuote, selectQuote } from 'Quotes/selectors';
import { selectHasShadowNNI } from 'Order/OrderBuilder/shared/utils/hasShadowNNI';
import { featureFlag } from 'FeatureFlags/utils/hasFeatureEnabled';
import { Feature } from 'FeatureFlags/types';

export const useSecondaryCircuitsSupported = (price: IPriceData) => {
  const quote = useSelector(selectQuote);
  const hasShadowVLAN = useSelector(selectHasShadowNNI);
  const isFttxQuote = useSelector(isFTTXQuote);
  //const isManagedDIA = quote.location.aEnd.is_managed_dia;

  if (!shouldRenderForProductType(quote.productType!)) return false;
  if (!shouldRenderForFttxQuote(isFttxQuote)) return false;
  if (!shouldRenderForConnectionType(price.product_sub_type)) return false;
  if (!shouldRenderForShadowVLAN(hasShadowVLAN)) return false;

  if (quote.productType === ProductType.P2NNI) {
    if (!shouldRenderForRawSupplier(price.b_end_access_type, price.b_end_access_type, quote.productType)) return false;
  } else if (quote.productType === ProductType.P2P || quote.productType === ProductType.OpticalP2P) {
    if (!shouldRenderForRawSupplier(price.a_end_access_type, price.b_end_access_type, quote.productType)) return false;
  } else if (quote.productType === ProductType.DIA) {
    if (!shouldRenderForRawSupplier(price.a_end_access_type, price.a_end_access_type, quote.productType)) return false;
    // if (isManagedDIA) {
    //   return isMdiaForRO2FeatureEnabled();
    // }
  }

  return true;
};

export function shouldRenderForProductType(productType: ProductType) {
  return featureFlag.getAttribute<boolean>(Feature.SecondaryCircuits, productType);
}

function shouldRenderForRawSupplier(a_end_supplier: string | null | undefined, b_end_supplier: string | null | undefined, productType: ProductType) {
  if (!isSupplier(a_end_supplier)) return false;
  if (!isSupplier(b_end_supplier)) return false;
  return shouldRenderForSupplier(a_end_supplier, b_end_supplier, productType);
}

export function shouldRenderForSupplier(a_end_supplier: Supplier | undefined, b_end_supplier: Supplier | undefined, productType: ProductType) {
  let supportedSuppliers = [Supplier.OPENREACH];
  if (productType === ProductType.OpticalP2P || productType === ProductType.P2P) {
    supportedSuppliers = [...supportedSuppliers,  Supplier.NONE];
  }
  if (a_end_supplier && !supportedSuppliers.includes(a_end_supplier)) return false;
  if (b_end_supplier && !supportedSuppliers.includes(b_end_supplier)) return false;
  if (a_end_supplier === Supplier.NONE && b_end_supplier === Supplier.NONE) return false;
  return true;
}

export function shouldRenderForShadowVLAN(hasShadowVLAN: boolean) {
  return !hasShadowVLAN;
}

export function shouldRenderForQuoteStatus(quoteStatus: QuoteStatus) {
  return quoteStatus === QuoteStatus.PRICED;
}

export function shouldRenderForConnectionType(connectionType: ConnectionType | ProductSubType | null) {
  return connectionType === 'Ethernet' || connectionType === 'ethernet' || connectionType === 'optical';
}

export function shouldRenderForFttxQuote(isFttxQuote: boolean) {
  return !isFttxQuote;
}

export function isMdiaForRO2FeatureEnabled(): boolean {
  return !!featureFlag.getAttribute<boolean>(Feature.SecondaryCircuits, 'isMDIAEnabled');
}
